export var appHost = process.env.APP_HOST || 'localhost:3000';
export var appScheme = process.env.APP_SCHEME || 'http';
export var appDomain = process.env.APP_DOMAIN || 'localhost';
export var wsScheme = process.env.WS_SCHEME || 'ws';
export var wsPort = process.env.WS_PORT || '4000';
